<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name"></sui-page-header>
    <sui-page-contents>
      <!--ur-page title="녹취"-->
        <audio controls>
          <source src="sample.wav" type="audio/wav">
        </audio>
        <div class="comm_btn_wrap">
          <sui-button type="button" class="comm_btn_border"  @click="onRecordingDownload">{{ $t("MSG_BTN_RECORDING_DOWNLOAD") }}</sui-button>
        </div>
      <!--/ur-page-->
    </sui-page-contents>
  </sui-page>
</template>

<script>
  import BasePage from '~cm/components/BasePage';

  export default {
    name: "PGE_AIC_00013",
    extends: BasePage,

    props: {
      closePagePopup: {
        type: Function,
        default: () => {},
      },
      pageInitialData: {
        type: Object,
        default() {
          return {};
        },
      },
    },

    data() {
      return {
        localdata0: [],
        searchText: '',
      };
    },

    created() {      
    },

    computed: {
    },
    
    watch: {      
    },

    mounted() {
      //console.log(this.pageInitialData.conversation.scenarioName);
      console.log(this.pageInitialData);
      // console.log(JSON.stringify(this.$options.name));      
      //this.outCallScheduleAsk.scheduleId = this.pageInitialData.scheduleId;
      //this.getSchedule();
    },
    
    methods: {
      onRecordingDownload(){

      },
      onSearchText(){

      },
    },

  };
</script>
<style scoped>

</style>
